module.exports = __webpack_public_path__ + "static/riodejaneiro-66be00360e3e2c7a96fcb114d0338fe7.png";